import { useMutation } from '@tanstack/react-query';

import { useApiSDK } from '../../contexts/apiSdkContext';

type TUserCredentials = {
  username: string;
  password: string;
};

type TTokens = {
  accessToken: string;
  refreshToken: string;
};

type TLogin = {
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  mutateAsync: (body: TUserCredentials) => Promise<TTokens | undefined>;
};

function useLogin(): TLogin & { error: unknown } {
  const sdk = useApiSDK();

  const { isError, isLoading, isSuccess, mutateAsync, error } = useMutation<TTokens, unknown, TUserCredentials>({
    mutationFn: async (body: TUserCredentials) => {
      const data = await sdk.auth.login(body.username, body.password);
      if (data) {
        sdk.setAuthToken(data.accessToken);
        return data;
      }
      throw new Error('Login failed: no data returned');
    },
  });

  return { isError, isLoading, isSuccess, mutateAsync, error };
}

export { useLogin };
